export const createDefaultContent = () => {
  return {
    integration_id: '',
    form_inputs: {},
  }
};
